import { idr, usd } from '../../shared/currency';
import get from 'lodash/get';
import dayjs from 'dayjs';

import { categoryLib, getPremiumBysupportedPaymentTerm } from 'clientUtils';

export const PDFTemplate = {
	compareLayout: (category) => {
		const template = {
			header: `
				<header class="template__header"
					style="
						width: 100%;
						padding: 16px;
						position: relative;
						padding-left: 4px;
						padding-right: 4px;
						margin: 0 24px;
						margin-left: 0;
					"
				>
					<div
						style="
							display: flex;
							align-items: center;
							justify-content: space-between;
							width: 100%;
						"
					>
						<a href="https://lifepal.co.id" target="_blank">
							<img class="template__logo" src="https://lifepal.co.id/static/images/lifepal-logo.png" alt="@lifepal_logo"
								style="
									height: 41px;
									width: 123px;
									display: inline-flex;
									align-self: center;
								"
							/>
						</a>
						<h4 class="template__title" style="
							font-family: Montserrat;
							font-size: 24px;
							font-weight: bold;
							font-stretch: normal;
							font-style: normal;
							line-height: 1.21;
							letter-spacing: normal;
							color: #333;
							text-transform: capitalize;
						">${get(categoryLib, category, '-')} Insurance</h4>
					</div>
					<div 
						style="
							display: flex;
							justify-content: center;
							align-items: center;
							bottom: 40px;
							width: 100%
						"
					>
						<hr style="width: 85%; color: #717171"; />
						<span 
							style="
							font-size: 12px;
							font-weight: normal;
							font-stretch: normal;
							font-style: normal;
							line-height: 1.29;
							letter-spacing: normal;
							color: #717171;
							"
						>Ringkasan Premi</span>
					</div>
				</header>
			`,
			footer: `
				<div style="font-size: 15px;">
					<div class="footer__title" style="
						text-align: left;
						font-size: 10px;
						font-weight: normal;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.5;
						letter-spacing: normal;
						text-align: left;
						color: #717171;
					">
						Catatan :
					</div>
					<span style="
						font-family: Montserrat;
						font-size: 8px;
						font-weight: normal;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.5;
						letter-spacing: normal;
						text-align: left;
						color: #717171;
					">
						Harga pada Penawaran Produk Asuransi ini merupakan ilustrasi dari harga asuransi Anda sebelum mendapatkan
						informasi yang sebenar-benarnya terkait Informasi Anda dan persetujuan dari Perusahaan Asuransi.
						Informasi yang terdapat pada Penawaran Produk Asuransi Lifepal.co.id selalu diperbarui dan dapat berubah
						sewaktu-waktu tanpa pemberitahuan sebelumnya mengikuti peraturan yang berlaku.
					</span>
				</div>
			`
		};
		return template;
	},
	compare: (data, category) => {
		const isAuto = data.quote.category === 'auto' || data.quote.category === 'moto';
		const isTravel = data.quote.category === 'travel';
		const isConstantTravelling = !!data.quote.longestDuration;
		const { appliedDiscountList } = data;
		const { compareItem } = data;
		const carSpecification = isAuto ? data.quote.namePlan.split('_') : '';

		const getValue = (plan, benefit, title) => {
			let value = '-';

			Object.keys(plan.product.attributes).forEach(attribute => {
				if (benefit.title === attribute) {
					const text = plan.product.attributes[attribute];
					if (text === 'No') { value = 'Tidak'; }
					else if (text === 'Yes') { value = 'Ya'; }
					else if (text === 'Optional') { value = 'Opsional'; }
					else { value = text; }
				}
			});

			plan.benefit_groups.forEach(benefits => {
				if (benefits.name === title) {
					benefits.benefits.forEach(d => {
						if (d.name === benefit.title) {
							if (d.coverage.as_billed) {
								value = 'Sesuai Tagihan';
							} else if (d.coverage.value_amount > 0) {
								value = d.coverage.currency === 'USD'
									? usd(d.coverage.value_amount)
									: idr(d.coverage.value_amount);
							} else if (d.coverage.value_text.includes('Optional')) {
								value = '-';
								const foundAdditionalBenefit = plan.additional_benefit.find(benefit => benefit.name === d.name);
								if (foundAdditionalBenefit) {
									value = 'Ya';
								}
							} else {
								value = d.coverage.value_text || '-';
							}
						}
					});
				}
			});

			return value;
		};

		const getIcon = (value) => {
			let element;
			if (value === 'Ya') {
				element = `<i class="icon ion-md-checkmark color-lp-blue"></i> ${value}`;
			} else if (value === 'Tidak') {
				element = `<i class="icon ion-md-close color-lp-red"></i> ${value}`;
			} else if (value === 'Opsional') {
				element = `<i class="icon ion-md-add color-lp-yellow"></i> ${value}`;
			}

			return element ? element : value;
		};

		const getElement = (value, title) => {
			return (
				`<p class=${title === 'Fitur' ? 'fiturs' : 'plan__item'}>${value}</p>`
			);
		};

		const getLinkElement = (link, i) => {
			if (!link) {
				return '<p class="plan__item">-</p>'
			}

			return `<a href="${link}" class="plan__item" key="link-brochure-${i}">
				<img 
					src="https://lifepal.co.id/static/images/icons/document.png" 
					alt=""
					style="
						width: 100%
						height: auto;
						margin-right: 12px;
					"
				/>
				Lihat RIPLAY
			</a>`
		}

		const getTitileWithIcon = (plan, benefit, title) => {
			const value = getValue(plan, benefit, title);
			return getElement(getIcon(value), title);
		};

		const getTitileWithIDR = (plan, benefit, index) => {
			const benefitsItem = plan.additional_benefit.find(item => item.name === benefit);
			let value = '-';
			if (benefitsItem) {
				const additionalBenefitsByIndex = data.compareItem[index].additionalBenefits;
				const matchAdditionalBenefits = additionalBenefitsByIndex.find(row => row.name === benefit);

				value = `s.d. ${idr(matchAdditionalBenefits.value)}`;
				if (benefitsItem.category_price === 0) {
					value = `s.d. ${idr(data.tsi)}`
				} else if (benefitsItem.category_price === 2) {
					value = `s.d. ${idr(matchAdditionalBenefits.value)} untuk ${matchAdditionalBenefits.qty} orang`;
				} else if (benefitsItem.category_price === 3) {
					value = 'Ya';
				}
			}
			return (
				`<p class="fiturs">${value}</p>`
			);
		};

		const getPremiumWithPaymentTerm = (data) => {
			const { paymentTerm, amount, isTravel, isConstantTravelling, compareDetail } = data;
			const isDiscountApplied = appliedDiscountList.some(appliedDiscount => appliedDiscount.id === compareDetail.id);
			const additionBenefits = compareItem.find(item => item.id === compareDetail.id);
			if (isDiscountApplied) {
				let index = appliedDiscountList.findIndex(appliedDiscount => appliedDiscount.id === compareDetail.id);
				return (
					`
						<h6 class="product__quote">
							<span class="before__discount">
								${idr(amount)} / ${isTravel
						? isConstantTravelling ? compareDetail.product.support_monthly ? 'Bulan' : 'Tahun' : 'Trip'
						: additionBenefits?.term ? (`${additionBenefits.term} ${paymentTerm}`) : paymentTerm
					}
							</span>
						</h6>
						<h6 class="product__quote">
							${idr(amount - (amount * (appliedDiscountList[index].discountPercentage / 100)))} / ${isTravel
						? isConstantTravelling ? compareDetail.product.support_monthly ? 'Bulan' : 'Tahun' : 'Trip'
						: additionBenefits?.term ? (`${additionBenefits.term} ${paymentTerm}`) : paymentTerm
					}
						</h6>
					`
				)
			} else {
				return (
					`
						<h6 class="product__quote">
							${idr(amount)} / ${isTravel
						? isConstantTravelling ? compareDetail.product.support_monthly ? 'Bulan' : 'Tahun' : 'Trip'
						: paymentTerm
					}
						</h6>
					`
				)
			}
		};

		const getProviderWithDistance = (provider) => {
			if (provider && provider.displayName && provider.distance) {
				const distanceInKm = (provider.distance / 1000).toFixed(1);
				return (
					`<p class="fiturs fiturs__location--name">
						<span class="color-lp-blue">${provider.displayName}</span>
						<span class="fiturs__location--distance">
							<i class="icon ion-ios-pin"></i>
							<span class="fiturs__distance">
								${distanceInKm} Km
							</span>
						</span>
					</p>`
				);
			}

			return (
				`<p class="fiturs">-</p>`
			);
		};

		const template = {
      structure: `
				<div class="proposal-header-list">
					<img src="https://storage.googleapis.com/storages.lifepal.tech/assets/static/footer-blue-list.png" />
				</div>
				<div class="proposal-header-gradient"></div>
        <div class="proposal__container" id="proposal-container">
          <header class="proposal-header">
            <img
							src="https://lifepal.co.id/static/images/lifepal-logo.png"
							alt="lifepal-logo"
							width="100px"
							height="auto"
						/>
						<div class="badge">
							<p>ASURANSI ${get(categoryLib, category, '-').toUpperCase()}</p>
            </div>
          </header>
          <div class="comparison__container">
						<div class="title">
							<p>Ringkasan Premi</p>
							<div style="
								width: 100%;
								margin: 12px 0;
								border-bottom: 2px dashed #e2e8f0;
							"></div>
						</div>
            ${isAuto ? (
              `
                <div class="car__specification">
                  <h4 class="specification__title">Spesifikasi Mobil Anda</h4>
                  <div class="specification__grid">
                    <div class="specification">
                      <span>Brand</span>
                      <span>: ${carSpecification[0]}</span>
                    </div>
                    <div class="specification">
                      <span>Model</span>
                      <span>: ${carSpecification[1]}</span>
                    </div>
                    <div class="specification">
                      <span>Harga Mobil</span>
                      <span>: ${idr(data.tsi)}</span>
                    </div>
                    <div class="specification">
                      <span>Type</span>
                      <span>: ${carSpecification[2]}</span>
                    </div>
                    <div class="specification">
                      <span>Tahun</span>
                      <span>: ${data.quote.year}</span>
                    </div>
                  </div>
                </div>
              `) : ``
            }
            <article class="template__body">
              <div class="product__brands">
                <div class="product__card empty__card"></div>
                ${data.compareData.map(compareDetail => {
                  const { amount, paymentTerm } = getPremiumBysupportedPaymentTerm(compareDetail);
                  return (
                    `
                      <div class="product__card">
                        <img 
													src="${compareDetail.product.brand.logo_url}"
													style="height: auto; width: 90px;"
													alt="brand__logo" class="product__logo" 
												/>
                        <h4 class="product__name">
                          ${isAuto ? `${compareDetail.product.name}` : `${compareDetail.product.name} - ${compareDetail.name}`}
                        </h4>
                        ${getPremiumWithPaymentTerm({
                          amount, paymentTerm, isTravel,
                          isConstantTravelling, compareDetail
                        })}
                      </div>
                    `
                  );
                }).join('')}
              </div>
              <div class="plans">
                ${isAuto ? (
                  `
                    <div class="plan__table">
                      ${data.additionalBenefitGroups.map(additionalBenefit => (
                        `
                          <div class="plan__body">
                            <p class="fiturs">${additionalBenefit}</p>
                            ${data.compareData.map((plan, i) => `${getTitileWithIDR(plan, additionalBenefit, i)}`).join('')}
                          </div>
                        `
                      )).join('')}
                    </div>
                  `) : ``
                }
                ${data.benefitGroups.map(group => (
                    `
                      <div class="plan__table">
                        <div class="plan__header">
                          <h4 class="plan__heading">${group.title}</h4>
                        </div>
                        ${group.benefits.map(benefit => (
                          `
                            <div class="plan__body">
                              <p class=${group.title === 'Fitur' ? 'fiturs' : 'plan__item'}>${benefit.title}</p>
                              ${data.compareData.map(plan => `${getTitileWithIcon(plan, benefit, group.title)}`).join('')}
                            </div>
                          `
                        )).join('')
                        }
                      </div>
                    `
                  )).join('')
								}
								${(data.nearbyProviders && data.nearbyProviders.length > 0) ? (
                  `
                    <div class="plan__table">
                      <div class="plan__header">
                        <h4 class="plan__heading">Rekanan Terdekat</h4>
                      </div>
                      ${[...new Array(5)].map((_, i) => (
                        `
                          <div class="plan__body">
                            <p class="fiturs">
                              ${i < 1
                                ? `${isAuto ? 'Bengkel' : 'Rumah Sakit'} Terdekat`
                                : ''
                              }
                            </p>
                            ${data.nearbyProviders.map((providers) => getProviderWithDistance(providers[i])).join('')}
                          </div>
                        `)).join('')}
                    </div>
                  `) : ``
                }

								<div class="plan__table">
									<div class="plan__header">
										<h4 class="plan__heading">Informasi Lainnya</h4>
									</div>
									<div class="plan__body">
										<p class="fiturs">Ringkasan Produk & Layanan (RIPLAY)</p>
										${data.compareData.map((plan, i) => `${getLinkElement(plan.product.brochure, i)}`)}
									</div>
								</div>									
              </div>
            </article>
          </div>
          <div style="width: 100%; padding: 24px 20px;">
            <div class="footer__title" style="
              text-align: left;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #717171;
            ">
              Catatan :
            </div>
            <span style="
              font-family: Montserrat;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #717171;
            ">
              Harga pada Penawaran Produk Asuransi ini merupakan ilustrasi dari harga asuransi Anda sebelum mendapatkan
              informasi yang sebenar-benarnya terkait Informasi Anda dan persetujuan dari Perusahaan Asuransi.
              Informasi yang terdapat pada Penawaran Produk Asuransi Lifepal.co.id selalu diperbarui dan dapat berubah
              sewaktu-waktu tanpa pemberitahuan sebelumnya mengikuti peraturan yang berlaku.
            </span>
          </div>
        </div>
			`,
			style: `
				* {
					box-sizing: border-box;
					margin: 0;
					padding: 0;
        }

				.proposal-header-list {
					position: absolute;
					width: 100vw;
					left: 0;
					top: 0;
					height: 6px;
					background-color: #ea4b4b;
				}

				.proposal-header-list img {
					position: absolute;
					top: 0;
					width: 75%;
					height: 6px;
				}

				.proposal-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin: 38px 0 25px;
					padding: 0 20px;
				}

				.proposal-header-gradient {
					background-image: url("https://storage.googleapis.com/storages.lifepal.tech/assets/static/bg-gradient-comparison-1-half.png");
					background-repeat: no-repeat;
					background-size: 100vw auto;
					width: 100vw;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: -1;
				}

				.proposal-header .badge {
					margin-top: 10px;
					border-radius: 25px;
					padding: 10px 25px;
					box-shadow: #363d5514 5px 5px 5px;
				}
				.proposal-header .badge p {
					font-size: 0.75rem;
					font-weight: 700;
					line-height: 12px;
					letter-spacing: 0.04em;
					text-align: right;
				}

        .proposal__container {
           z-index: 2;
				}

				.comparison__container {
					z-index: 2;
					background-color: white;
					display: relative;
					width: 100vw;
					padding: 20px;
					margin: 0;
				}
				.title {
					font-family: Open Sans;
					font-size: 14px;
					font-weight: 700;
					line-height: 16px;
					letter-spacing: 0.02em;
					text-align: left;
				}
				.product__brands {
					display: flex;
					align-items: center;
					justify-content: space-evenly;
					flex: 1 1 1 1;
					height: 175px;
					width: 100%;
					border: 1px solid rgba(51, 51, 51, 0.2);
					margin-top: 16px;
					border-radius: 8px;
				}
				.product__name {
					font-size: 14px;
					font-weight: normal;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.71;
					letter-spacing: normal;
					text-align: center;
					color: #5e5e5e;
				}
				.product_logo {
					translate: scale(1.5);
				}
				.product__quote {
					font-size: 14px;
					font-weight: 500;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.29;
					letter-spacing: normal;
					text-align: center;
				}
				.product__card {
					display: flex;
					align-items: center;
					justify-content: space-around;
					flex-direction: column;
					padding: 8px;
					width: 25%;
					height: 100%;
				}
				.product__card:not(:last-child) {
					border-right: 1px solid rgba(51, 51, 51, 0.2);
				}
				.product__card:not(:first-child) {
					flex-grow: 1;
				}
				.plan__table {
					width: 100%;
					margin-top: 12px;
					border-radius: 8px;
					box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
				}
				.plan__header {
					height: 40px;
					display: flex;
					align-items: center;
					background: #164da6;
					border-top-right-radius: 4px;
					border-top-left-radius: 4px;
				}
				.plan__heading {
					font-size: 14px;
					font-weight: bold;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.29;
					letter-spacing: normal;
					text-align: left;
					color: #fff;
					padding-left: 4px;
				}
				.plan__body {
					display: flex;
					justify-content: space-evenly;
					width: 100%;
					height: 60px;
					border: 1px solid rgba(51, 51, 51, 0.2);
				}
				.plan__item {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 25% !important;
					height: 100%;
					padding: 4px;
					margin: 0;
					font-size: 14px;
					color: #333;
					font-weight: normal;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.2;
					letter-spacing: normal;
				}
				.plan__item:not(:last-child) {
					border-right: 1px solid rgba(51, 51, 51, 0.2);
				}
				.plan__item:not(:first-child) {
					flex-grow: 1;
				}
				.fiturs {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 25% !important;
					height: 100%;
					padding: 4px;
					margin: 0;
					font-size: 14px;
					color: #333;
					font-weight: normal;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.2;
					letter-spacing: normal;
				}
				.fiturs:not(:last-child) {
					border-right: 1px solid rgba(51, 51, 51, 0.2);
				}
				.fiturs:not(:first-child) {
					flex-grow: 1;
					background: #f5f5fa;
				}
				.fiturs:first-child {
					background: #d2e0f8 !important;
				}
				.fiturs__location--name {
					display: inline-flex;
					flex-direction: column;
				}
				.fiturs__location--distance {
					margin-top: 4px;
				}
				.fiturs__location--name span {
					text-align: center;
				}
				.fiturs__distance {
					margin-left: 4px;
				}
				.icon {
					margin-right: 8px;
				}
				.color-lp-red {
					color: #e81a1a;
				}				
				.color-lp-blue {
					color: #1d66dd;
				}
				.color-lp-yellow {
					color: #faaf40;
				}
				.color-lp-grey {
					color: #717171;
				}
				.before__discount {
					color: #c2c2c2;
					text-decoration: line-through;
				}
				.discount__badge {
					display: inline-block;
					height: 20px;
					width: 40px;
					background: #faaf40;
					color: #feefd9;
					text-align: center;
					border-radius: 2px;
					padding: 1px;
				}
				.car__specification {
					background: #164da6;
					color: #fff;
					padding: 16px;
					box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
					border-radius: 8px;
        }
        .specification__grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 4px;
        }
				.specification__title {
					border-bottom: 1px solid #fff;
					margin-bottom: 8px;
					padding-bottom: 8px;
				}
				.specification {
          display: grid;
          grid-template-columns: 0.5fr 1fr;
          align-items: center;
          margin-bottom: 12px;
				}
				.specification span {
					font-size: 12px;
					font-stretch: normal;
					font-style: normal;
					line-height: 1.5;
					letter-spacing: normal;
					text-align: left;
				}
				.specification span:first-child {
          font-weight: normal;
				}
				.specification span:last-child {
          font-weight: 500;
				}
			`,
		};
		return template;
	},
	application: (orderDetail, buyerValue, mainInsured, quotation) => {
		let namePlan;
		let regionCode;
		let autoYear;
		let totalSumInsured;
		const autoInformation = get(quotation, 'policyMembers', []).find(row => !!row.insuredItem);
		if (get(autoInformation, 'insuredItem')) {
			const { brand, model, type, region, year, sumInsured } = get(autoInformation, 'insuredItem');
			namePlan = `${brand} ${model} ${type}`;
			regionCode = region;
			autoYear = year;
			totalSumInsured = sumInsured;
		}
		const tableData = get(orderDetail, 'orderItems', []).filter(item => item.category === 'PREMIUM');

		const sortByCategory = (category, list = []) => {
			return list.sort((a, b) => {
				if (a.category === category) {
					return -1;
				} else {
					return 1;
				}
			});
		}
		const chargesSortedList = sortByCategory('CHARGES', orderDetail.orderItems);
		const premiumSortedList = sortByCategory('PREMIUM', chargesSortedList);

		const orderList = premiumSortedList
			.filter(item => item.category !== 'ADJUSTMENT')
			.map(item => ({
				...item,
				...(['PREMIUM', 'DISCOUNT'].includes(item.category) ? { amount: Number(item.amount) } : {}),
			}));

		const template = {
			structure: `
				<div class="quotation__wrapper">
					<div class="quotation__wrapper--header">
						<div class="section__icon">
							<a href="https://lifepal.co.id" target="_blank">
								<img class="template__logo" src="https://lifepal.co.id/static/images/lifepal-logo.png" alt="@lifepal_logo" />
							</a>
						</div>
						<div class="section__title">
							<h3>Quotation Slip</h3>
						</div>
						<div class="section__info">
							<p>Bandingkan, Menghemat dan Klaim Asuransi Dengan Mudah</p>
							<p>PT Abisatya Pialang Asuransi</p>
							<p>KEP-018/KMK.17/1992 APPARINDO 060-2001/APPARINDO/2019</p>
						</div>
					</div>
					<hr />
					<div class="quotation__wrapper--user">
						<div class="user__left">
							<div>
								<span>Untuk</span>
								<span className="full__name">${buyerValue.fullName}</span>
							</div>
							<div>
								<span>Email</span>
								<span>${buyerValue.email || 'N/A'}</span>
							</div>
							<div>
								<span>No. Hp</span>
								<span>0${buyerValue.phone}</span>
							</div>
							<div>
								<span>Subject</span>
								<span>Quotation Slip Untuk ${get(categoryLib, orderDetail.category, '-')}</span>
							</div>
						</div>
						<div class="user__right">
							<div>
								<span>Dari</span>
								<span>PT Abisatya Pialang Asuransi</span>
							</div>
							<div>
								<span>Nomor</span>
								<span>${orderDetail.humanId}</span>
							</div>
							<div>
								<span>Tanggal</span>
								<span>${dayjs(orderDetail.createdAt).format('DD MMMM YYYY')}</span>
							</div>
						</div>
					</div>
					<hr />
					${!(['auto', 'moto'].includes(orderDetail.category))
					? (
						`
							<div class="quotation__wrapper--information">
								<div class="information__item">
									<span>Nama Lengkap</span>
									<span class="full__name">${get(mainInsured, 'person.fullName', '')}</span>
								</div>
								<div class="information__item">
									<span>Jenis Kelamin</span>
									<span>${get(mainInsured, 'person.gender', '')}</span>
								</div>
								<div class="information__item">
									<span>Tanggal Lahir</span>
									<span>${get(mainInsured, 'person.dob', '')}</span>
								</div>
							</div>
						`
					)
					: (
						`
							<div class="quotation__wrapper--information">
								<div class="information__item">
									<span>Merek & Tipe Kendaraan</span>
									<span>${namePlan}</span>
								</div>
								<div class="information__item">
									<span>Wilayah</span>
									<span>${regionCode}</span>
								</div>
								<div class="information__item">
									<span>Tahun</span>
									<span>${autoYear}</span>
								</div>
							</div>
						`
					)
				}
				${(['auto', 'moto'].includes(orderDetail.category))
					? (
						`<hr />
						<div class="quotation__wrapper--information">
							<div class="information__item">
								<span>Total Uang Pertanggungan</span>
								<span>Untuk Kendaraan</span>
								<span>${idr(totalSumInsured)}</span>
							</div>
							<div class="information__item">
								<span></span>
								<span>Untuk Aksesoris</span>
								<span>0</span>
							</div>
							
							<div class="information__item">
								<span></span>
								<span></span>
								<div class="divider">
									<hr />
								</div>
							</div>
							<div class="information__item total">
								<span></span>
								<span>Total</span>
								<span>${idr(totalSumInsured)}</span>
							</div>
						</div>
						`
					)
					: ''
				}
				<hr />
				<div class="quotation__wrapper--information">					
					${orderList.map((item, i) => {
					let name = item.name;
					if (name.toUpperCase().includes('DISCOUNT VOUCHER')) {
						name = 'Discount';
					}
					return (
						`<div class="information__item">
									${i < 1 ? '<span>Jenis Cakupan</span>' : '<span></span>'}
									<span>${name}</span>
									<span>${idr(item.amount)}</span>
								</div>`
					)
				}).join('')
				}
					<div class="information__item">
						<span></span>
						<span></span>
						<div class="divider">
							<hr />
						</div>
					</div>
					<div class="information__item total">
						<span></span>
						<span>Premi Tahunan</span>
						<span>${idr(orderDetail.totalAmount)}</span>
					</div>
				</div>
				<hr />
				${orderDetail.category === 'auto'
					? (
						`
					<div class="quotation__wrapper--table">
						<table>
							<tr>
								<th>Jenis Cakupan</th>
								<th>Termasuk</th>
								<th>Nilai</th>
							</tr>
								${tableData.map(data =>
							`
										<tr>
											<td>${data.name}</td>
											<td><span>✓${' '}</span>Ya</td>
											<td>${idr(data.amount)}</td>
										</tr>
									`
						).join('')}
						</table>
					</div>`
					)
					: ''
				}
				<div class="quotation__wrapper--signature">
					<p>Salam Hormat</p>
					<img class="signature__logo" src="https://lifepal.co.id/static/images/signature-advisor.jpeg" alt="@lifepal_logo" />
					<p class="full__name">Hari Suryadi, APAI, CIIB</p>
					<p>Direktur Operasional dan Tata Kelola</p>
				</div>
				<hr />
				<div class="quotation__wrapper--footer">
					<div>
						<p>Lifepal - Teman Andalamu / PT Abisatya Pialang Asuransi</p>
						<p>Jl. Benda No. 92 RT5/RW4, RT.2/RW.4, Cilandak Tim., Kec. Ps. Minggu, Jakarta, Daerah Khusus Ibukota Jakarta 12560</p>
						<p>www.lifepal.co.id</p>
					</div>
				</div>
			</div>
			`,
			style: `
				<style>
					.quotation__wrapper {
						margin-right: auto;
						margin-left: auto;
						max-width: 1200px;
					}
					.quotation__wrapper--header {
						display: flex;
						margin-bottom: 30px;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					.quotation__wrapper--header .section__icon {
						width: 20%;
					}
					.quotation__wrapper--header .section__title {
						width: 35%;
						padding: 0 10px;
					}
					.quotation__wrapper--header .section__info {
						width: 45%;
					}
					.quotation__wrapper--header .section__info p {
						margin-top: 0;
						margin-bottom: 5px;
					}
					.quotation__wrapper--header .section__info p:first-child {
						font-weight: bold;
					}
					.quotation__wrapper--user {
						display: flex;
						margin-top: 24px;
						margin-bottom: 24px;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					.user__left, .user__right {
						width: 50%;
					}
					.user__left div, .user__right div {
						display: flex;
						margin-bottom: 16px;
					}
					.user__left div span, .user__right div span {
						width: 20%;
					}
					.user__left div span, .user__right div span.full__name {
						text-transform: capitalize;
					}
					.user__left div span:last-child, .user__right div span:last-child {
						width: auto;
						color: #717171;
						font-weight: bold;
					}
					.quotation__wrapper--information {
						margin-top: 24px;
						margin-bottom: 24px;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					.quotation__wrapper--information .information__item {
						display: flex;
						margin-bottom: 16px;
					}
					.quotation__wrapper--information .information__item span {
						width: 30%;
					}
					.quotation__wrapper--information .information__item span.full__name {
						text-transform: capitalize;
					}
					.quotation__wrapper--information .information__item span:last-child {
						width: auto;
						color: #717171;
						font-weight: bold;
					}
					.quotation__wrapper--information .information__item.total span:last-child {
						color: #1d66dd;
					}
					.divider {
						width: 10%;
					}
					.quotation__wrapper--table {
						margin-top: 24px;
						margin-bottom: 24px;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					table {
						border-collapse: collapse;
						width: 100%;
						table-layout: fixed;
  					width: 100%;
					}
					td, th {
						border: 1px solid #dddddd;
						text-align: left;
						padding: 8px;
						padding: 15px;
					}
					td span {
						color: #1d66dd;
					}
					.quotation__wrapper--signature {
						margin-bottom: 16px;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					.quotation__wrapper--signature .signature__logo {
						width: 150px;
					}
					.quotation__wrapper--signature p.full__name {
						color: #717171;
						font-weight: bold;
					}
					.quotation__wrapper--footer {
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
						width: 100%;
						text-align: center;
						margin-top: 24px;
						margin-bottom: 24px;
					}
					.quotation__wrapper--footer p {
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
					}
					.quotation__wrapper--footer p:first-child {
						color: #717171;
						font-size: 14px;
						font-weight: normal;
						font-family: Montserrat;
						font-weight: bold;
					}
				</style>
			`,
		};
		return template;
	}
};
